module.exports = {
    
    props: {
        data: {
            type: Object,
            required: true,
        }
    },
    
    data() {
        return {
            course: this.data.course,
            schedules: this.data.schedules,
            paymentPayload: {
                course_id: this.data.course.id,
                schedule_id: null,
            },
        }
    },
    
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.paymentPayload.schedule_id = urlParams.has('date') ? parseInt(urlParams.get('date')) : null;
    },
    
    computed: {
        
        isSchedulable() {
            return ['webinar', 'onsite'].includes(this.course.driver);
        },
        
        isOnWaitingList(){
            return this.data.unscheduled;
        },
        
        isEnrolled() {
            if (!App.config.userId) return false;
            var enrrolled = false;
            
            if (this.isSchedulable) {
                if(this.isOnWaitingList) return true;
                
                this.schedules.forEach(schedule => {
                    schedule.students.forEach(student => {
                        if (student.id == App.config.userId) {
                            enrrolled = student.onsite;
                        }
                    })
                })
            } else {
                this.course.students.forEach(student => {
                    if (student.id == App.config.userId) {
                        enrrolled = student.online;
                    }
                })
            }
            return enrrolled;
        },
    }
}